import { NextPage } from "next";

import { LoadingModule } from "@/components/modules/loading";
import { useGlobalContext } from "@/hooks/use-global-context";

import { ListWorkspace } from "@/modules/list-workspace";
import { useSetLayoutParams } from "@/context/app-layout";

const LAYOUT_PARAMS = {
  navTitle: "",
  meta: {
    title: "Homepage - Glencoco",
  },
  pageContainerClassName: "overflow-auto",
  // overflow-x-auto in the "contentContainerClassName" allows this page to
  // scroll horizontally like a notion table
  contentContainerClassName: "overflow-x-auto bg-white",
  headerClassName: "!max-w-[unset] px-0",
  isBackgroundVisible: false,
};

const HomepageWithDataFetched = () => {
  const { isUserLoaded } = useGlobalContext();

  return isUserLoaded ? <ListWorkspace /> : <LoadingModule />;
};

const Homepage: NextPage = () => {
  useSetLayoutParams(LAYOUT_PARAMS);

  return <HomepageWithDataFetched />;
};

export default Homepage;
